import { XCircle } from "lucide-react";
import { formatApiErrorDetail } from "@/lib/api";

export const card = "card-tech rounded-2xl p-6";
export const btn = "inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-colors disabled:opacity-60";
export const primary = `${btn} bg-cyan-400 text-[#07090E] hover:bg-cyan-300`;
export const ghost = `${btn} border border-cyan-400/50 text-cyan-200 hover:bg-cyan-400/10`;
export const danger = `${btn} border border-red-400/40 text-red-200 hover:bg-red-500/10`;
export const field = "w-full rounded-lg border border-white/10 bg-[#07090E] px-3 py-2 text-sm text-white outline-none focus:border-cyan-400/60";
export const detail = (e) => e.response?.data?.detail;

export const Problem = ({ d, testId }) => {
  if (!d) return null;
  const obj = typeof d === "object" && !Array.isArray(d) ? d : { message: formatApiErrorDetail(d) };
  return (
    <div data-testid={testId} className="mt-4 rounded-xl border border-red-400/30 bg-red-500/10 p-4 text-sm text-red-200">
      <p className="flex items-center gap-2 font-semibold"><XCircle className="h-4 w-4" />{obj.message}</p>
      {obj.twentyi_error && <p className="mt-1 text-red-300/90">20i said: {obj.twentyi_error}</p>}
      {obj.steps?.length > 0 && <ol className="mt-2 list-decimal space-y-1 pl-5 text-red-100/90">{obj.steps.map((s) => <li key={s}>{s}</li>)}</ol>}
    </div>
  );
};

export const PackageSelect = ({ pkgs, value, onChange, testId }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId} className={field}>
    <option value="">{pkgs === null ? "Loading…" : pkgs.length ? "Choose a package" : "No packages"}</option>
    {(pkgs || []).map((p) => (
      <option key={p.id} value={p.id} disabled={p.protected} data-testid={`${testId}-option-${p.id}`}>{p.name}{p.protected ? " — Protected live site" : ""}</option>
    ))}
  </select>
);

export const SslBadge = ({ status, testId }) => {
  const tone = { Active: "border-emerald-400/40 text-emerald-200", Pending: "border-amber-400/40 text-amber-200", Failed: "border-red-400/40 text-red-200" }[status] || "border-white/10 text-slate-300";
  return <span data-testid={testId} className={`rounded-full border px-2.5 py-0.5 text-xs font-semibold ${tone}`}>SSL {status || "—"}</span>;
};
